import { createApi } from "@reduxjs/toolkit/query/react";

import { encryptionOnlyBaseQuery } from '../../utils/authentication/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/middleware/responseMiddleware2";

export const authApi = createApi({
    baseQuery: encryptionOnlyBaseQuery,
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (details) => ({
                url: '/Authentication/userLogin',
                method: 'POST',
                body: details,
            }),
            invalidateTags: ['authentication'],
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: "/UserManagement/ForgotPassword",
                method: "POST",
                body: data,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        changePassword: builder.mutation({
            query: (data) => ({
                url: "/UserManagement/ChangeUserPassword",
                method: "POST",
                body: data,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        validateInvite: builder.query({
            query: (token) => ({
                url: "/PublicCandidateAssessment/ValidateInvite",
                method: "GET",
                params: { data: token }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendOtp: builder.mutation({
            query: (data) => ({
                url: "/PublicCandidateAssessment/SendOtp",
                method: "POST",
                body: data,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        verifyOtp: builder.mutation({
            query: (data) => ({
                url: "/PublicCandidateAssessment/VerifyOtp",
                method: "POST",
                body: data,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRulesAndSummary: builder.query({
            query: (sessionToken) => ({
                url: "/PublicCandidateAssessment/GetRulesAndSummary",
                method: "GET",
                headers: { "Assessment-Session-Token": sessionToken }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        startTest: builder.mutation({
            query: (sessionToken) => ({
                url: "/PublicCandidateAssessment/StartTest",
                method: "POST",
                headers: { "Assessment-Session-Token": sessionToken }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTestQuestions: builder.query({
            query: (sessionToken) => ({
                url: "/PublicCandidateAssessment/GetTestQuestions",
                method: "GET",
                headers: { "Assessment-Session-Token": sessionToken }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        autoSaveAnswers: builder.mutation({
            query: ({ sessionToken, answers }) => ({
                url: "/PublicCandidateAssessment/AutoSaveAnswers",
                method: "POST",
                headers: { "Assessment-Session-Token": sessionToken },
                body: { answers }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitTest: builder.mutation({
            query: ({ sessionToken, submitType, answers }) => ({
                url: "/PublicCandidateAssessment/SubmitTest",
                method: "POST",
                headers: { "Assessment-Session-Token": sessionToken },
                body: { submitType, answers }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useLoginMutation,
    useForgotPasswordMutation,
    useChangePasswordMutation,
    useLazyValidateInviteQuery,
    useSendOtpMutation,
    useVerifyOtpMutation,
    useLazyGetRulesAndSummaryQuery,
    useStartTestMutation,
    useLazyGetTestQuestionsQuery,
    useAutoSaveAnswersMutation,
    useSubmitTestMutation
} = authApi;